<template>
  <vs-popup class="holamundo asset-modal" :class="{'hide-metadata': !showMetadata}" title="View asset" :active.sync="popupActive">
    <div class="ga-modal-wrapper">
      <div class="ga-modal-content">
        <div class="d-flex align-start">
          <h2 class="ga-modal-title" v-html="getTitle()"/>
          <a :href="viewLink" class="ga-modal-view-btn" target="_blank" v-if="viewLink && item.asset_type !== 'coobos' && showMetadata">View</a>
          <div class="coobo-links" v-if="item.asset_type === 'coobos'">
            <a v-for="t in cooboCdnTypes"
               v-if="showMetadata && item[t.value]"
               class="ga-modal-view-btn"
               :href="getCooboLink(item[t.value])"
               :key="t.value"
               target="_blank">
              {{ t.name }}
            </a>
            <div v-for="t in cooboCdnTypes"
               v-if="!showMetadata && item[t.value]"
               @click="setCdnType(t.value)"
               :class="{selected: cdnType === t.value}"
               :key="t.value"
               class="ga-modal-view-btn">
              {{ t.name }}
            </div>
          </div>
        </div>

        <div class="global-asset-iframe-wrapper" v-if="['simulations', 'coobos'].includes(item.asset_type) && !showMetadata">
            <iframe class="global-asset-iframe" :src="getIframeLink()" allowfullscreen></iframe>
        </div>
        <div v-if="item.asset_type === 'videos'">
          <div class="d-flex align-center justify-end" v-if="showLanguages && showMetadata">
            <span class="label">Language: </span>
            <v-select
              class="left language-select"
              name="currentLanguage"
              :options="filteredLanguages"
              v-model="selectedLanguage"
              label="name"
              :loading="!filteredLanguages.length"
              :searchable="false"
              :clearable="false"
              @input="onLangChanged"
            />
          </div>
          <vx-input-group class="custom-input-group" v-if="cdnUrlKey && (showLanguages || !showMetadata)">
            <div class="vx-input-group-append flex-grow">
              <div class="append-text btn-addon">
                <vs-button
                  :disabled="!item[v.value]"
                  color="primary"
                  type="border"
                  v-for="(v, i) in videoVimeoTypes"
                  :key="i"
                  @click="setCdnUrlType(v.value)"
                  class="radiobtn"
                  :class="{selected: cdnUrlKey === v.value}">
                  {{ v.name }}
                </vs-button>
              </div>
            </div>
          </vx-input-group>

          <HLSPlayer :hlsUrl="hlsUrl" :is-hls="false" :full-width="true"/>
        </div>
        <div class="ga-modal-table-wrapper" v-if="showMetadata">
          <div class="ga-modal-table">
            <table class="meta-table mt-3">
              <thead>
              <th colspan="2">Required{{ demoContent ? `` : ' by PowerSchool'}}:</th>
              </thead>
              <tbody>
              <tr v-for="(key, index) in getSortedPowerSchoolFields(powerSchoolFields)" :key="index">
                <td  style="width: 300px">
                  <div>
                    <div class="table-input capitalize">
                      {{ mapFieldKey(key) }}
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <div class="table-input d-flex" v-html="powerSchoolFields[key]" />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="ga-modal-table">
            <table class="meta-table mt-3">
              <thead>
                <th colspan="2">Embibe fields:</th>
              </thead>
              <tbody>
                <tr v-for="(key, index) in Object.keys(embibeFields)" :key="index">
                  <td  style="width: 300px">
                    <div>
                      <div class="table-input capitalize">
                        {{ mapFieldKey(key) }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      <div class="table-input d-flex" v-html="embibeFields[key]" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ga-modal-table" v-if="lmsFields && lmsFields.length">
            <table class="meta-table mt-3">
              <thead>
              <th colspan="2">Learning maps:</th>
              </thead>
              <tbody>
              <tr v-for="(lm, index) in lmsFields" :key="index">
                <td  style="width: 300px">
                  <div>
                    <div class="table-input capitalize">
                      {{ `Learning map ${index + 1}` }}
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <div class="table-input d-flex" v-html="lm"/>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>

import HLSPlayer from '../HLSPlayer';
import vSelect from "vue-select";
import { hcLanguages } from "@/utils/constants/hcLanguages.js";
import { languages } from "@/utils/constants/languages.js";
import getVimeoLink from "@/utils/getVimeoLink.js";

export default {
  props: {
    _item: Object,
    showLanguages: {
      type: Boolean,
      default: true
    },
    withLink: {
      type: Boolean,
      default: false
    },
    demoContent: {
      type: Boolean,
      default: false
    },
    showMetadata: {
      type: Boolean,
      default: true
    },
    showCooboCdnTypes: {
      type: Array,
      default: () => [],
    }
  },
  components: {vSelect, HLSPlayer},
  data() {
    return {
      apiUrl: "https://preprodms.embibe.com",
      popupActive: true,
      isAction: false,
      hlsUrl: null,
      cdnUrlKey: null,
      filteredLanguages: [],
      selectedLanguage: {},
      videoVimeoTypes: [
        {value: "url_no_anchor", name: "With Voice"},
        {value: "url", name: "With Anchor"},
        {value: "url_no_anchor_no_narration", name: "Without Voice"}
      ],
      // videoCdnTypes: [
      //   {value: "cdn_url_no_anchor", name: "With Voice"},
      //   {value: "cdn_url", name: "With Anchor"},
      //   {value: "cdn_url_no_anchor_no_narration", name: "Without Voice"}
      // ],
      cooboCdnTypes: [
        {value: "cdn_url_without_anchor", name: "With Voice"},
        {value: "cdn_url_with_anchor", name: "With Anchor"},
        {value: "cdn_url_without_anchor_without_voice", name: "Without Voice"}
      ],
      hlsLinks: {},
      vimeoLinks: {},
      powerSchoolFields: {},
      embibeFields: {},
      lmsFields: [],
      escapeKeysMap: {
        simulations: ["category", "topic_id", "widget_type", "learnpath_name", "learnpath_code", "subject", "goal", "exam", "unit", "chapter", "topic", "format_reference", "final_score", "subtype"],
        coobos: ["status", "widget_type", "learnpath_code", "subject", "goal", "exam", "unit", "chapter", "topic", "format_reference", "final_score", "subtype"],
        videos: ["source", "widget_type", "short_description", "learnpath_name", "learnpath_code", "learnpath_name_format", "goal", "exam", "unit", "chapter", "topic", "format_reference", "final_score", "subtype"]
      },
      fieldsMap: {
        id: "UniqueId",
        coobo_id: "UniqueId",
        video_id: "UniqueId",
        asset_type: "ResourceFormat"
      },
      fieldsOrder: ["uniqueid","language","resourceformat","title","description","url","standardcodes","framewokcode","iscurated","productid","framebreaker","operation","audience","grades","content_area","mobilefriendly","depth_of_knowledge","application","timetocomplete","purpose","includesrubric","timetoscore"],
      bodyOverflow: '',
      cdnType: ''
    }
  },
  mounted() {
    this.popupActive = true;
    this.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    if (this.showCooboCdnTypes.length) {
      this.cooboCdnTypes = this.cooboCdnTypes.filter(t => this.showCooboCdnTypes.includes(t.value))
    }

    if (!this.showMetadata) {
      let tempCdnType;
      for (let ct of this.cooboCdnTypes) {
        if (this.item[ct.value]) {
          tempCdnType = ct.value;
          break
        }
      }
      this.cdnType = tempCdnType;
    }
    this.updateFields();
    if (this.item.asset_type === 'videos') {
      this.cdnUrlKey = this.videoVimeoTypes.map(t => t.value).filter(s => this.item[s] && this.item[s].includes('vimeo.com'))[0];
      this.getVimeoLink();
      const hcVideos = this.$store.state.hcData.videos
      const otherHcItems = this.item.video_id ? (hcVideos || []).filter(v => v.video_id === this.item.video_id) : [this.item];
      const langsToProcess = this.showLanguages ? this.item.video_id
        ? [{ name: 'English (India)', code: 'en' }, ...hcLanguages, ...languages]
        : hcLanguages : [{ name: 'en', code: 'en' }];
      const promises = langsToProcess.map(l => {
        return new Promise(resolve => {
          if (l.hcLang) {
            let dataToResolve = null;
            const data = otherHcItems.find(v => v.language === l.code);
            if (data) {
              const {language, title, description, url, url_no_anchor, url_no_anchor_no_narration} = data;
              dataToResolve = {
                ...l,
                data: {language, title, description, url, url_no_anchor, url_no_anchor_no_narration}
              }
            }
            resolve(dataToResolve);
          } else {
            this.$axios({
              url: `${this.apiUrl}/coobo_ms/csp-learning-maps`,
              data: {
                "id": this.item.video_id.toString(),
                "locale": l.code,
                "type": "video"
              },
              method: 'post',
            }).then(({data}) => {
              if (data && !data.error) {
                if (data.fullLms && this._item.language === l.code) {
                  this.lmsFields = data.fullLms;
                }
                const playbackUrls = data.playbackUrls
                  .filter(u => u.source === "VIMEO")
                  .reduce((acc, val) => ({...acc, [val.type]: val.url}), {});
                resolve({
                  ...l,
                  data: {
                    language: l.code,
                    title: data.title,
                    description: (data.descriptions.find(d => d.type === "LONG") || data.descriptions[0] || {}).value || "",
                    url: playbackUrls.WITH_ANCHOR_AND_NARRATION || "",
                    url_no_anchor: playbackUrls.NO_ANCHOR || "",
                    url_no_anchor_no_narration: playbackUrls.NO_ANCHOR_NO_NARRATION || ""
                  }
                })
              } else {
                resolve(null);
              }
            }).catch((e) => {
              console.log(e.message);
              resolve(null);
            })
          }
        })
      });
      Promise.all(promises).then(res => {
        this.filteredLanguages = res.filter(r => r);
        this.selectedLanguage = this.filteredLanguages.find(l => l.code === this._item.language);
      })
    }
    if (this.item.asset_type === 'simulations') {
      this.getCspLms(this.item.id.toString(), 'simulation');
    }
    if (this.item.asset_type === 'coobos') {
      this.getCspLms(this.item.coobo_id.toString(), 'coobo');
    }
  },
  destroyed() {
    document.body.style.overflow = this.bodyOverflow;
  },
  computed: {
    item() {
      let data = this.selectedLanguage ? this.selectedLanguage.data : {};
      return {...this._item, ...(data || {}) }
    },
    viewLink() {
      let link = ''
      if (this.item.asset_type === 'simulations') {
        const {language, id, simulation_url_web} = this.item;
        // .filter(l => l.name !== 'English (US)')
        link = !hcLanguages.map(l => l.name).includes(language) ? `https://school.embibe.com/teach/simulation/${id}?locale=${language}` : simulation_url_web;
      }
      if (this.item.asset_type === 'videos') {
        link = this.item.url_no_anchor_no_narration || this.item.url_no_anchor || this.item.url;
      }

      return link;
    }
  },
  watch: {
    popupActive() {
      if (!this.popupActive) {
        this.closeModal();
      }
    }
  },
  methods: {
    setCdnType(t) {
      this.cdnType = t;
    },
    onLangChanged() {
      this.updateFields();
      this.vimeoLinks = {};
      if (!this.item[this.cdnUrlKey]) {
        this.cdnUrlKey = this.videoVimeoTypes.map(v => v.value).filter(k => this.item[k])[0];
      }
      console.log(this.item);
      this.getVimeoLink();
    },
    updateFields() {
      const powerSchoolFields = {}, embibeFields = {};
      Object.keys(this.item).forEach((k) => {
        if (!this.escapeKeysMap[this.item.asset_type] || !this.escapeKeysMap[this.item.asset_type].includes(k)) {
          if (this.item[k]) {
            if (k.includes("url") || ["id", "_id", "coobo_id", "video_id", "asset_type", "title", "description", "duration", "language"].includes(k)) {
              powerSchoolFields[k] = this.item[k];
            } else {
              if (!k.match(/baraha/gi)) {
                embibeFields[k] = this.item[k];
              }
            }
          }
        }
      })
      powerSchoolFields.isCurated = true;
      this.powerSchoolFields = powerSchoolFields;
      embibeFields.licence = 'Embibe Owned'
      this.embibeFields = embibeFields;
    },
    closeModal() {
      setTimeout(() => {
        this.$emit('closeModal', this.isAction);
      }, 1)
    },
    setCdnUrlType(t) {
      if (this.item[t]) {
        this.cdnUrlKey = t;
        this.getVimeoLink();
      }
    },
    mapFieldKey(key) {
      let tempKey = this.fieldsMap[key] ? this.fieldsMap[key] : key;

      return tempKey.replace(/_/g, " ")
    },
    removeHTMLandImgLinks(inputString) {
      return inputString.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
    },
    getTitle() {
      let t = 'Custom Title'
      if (this.item.title) {
        t = this.item.title
      }

      return this.removeHTMLandImgLinks(t);
    },
    getCooboLink: (coobo_link) => {
      let cId = null;
      let match = coobo_link.match(/\/view\/(\S+)$/);
      if (match && match[1]) {
        cId = match[1];
      }
      return `https://school.embibe.com/create/view?id=${cId}&respect-video-controls=true&delete_marginal_slides=true`;
    },
    getHlsLink() {
      if (!this.cdnUrlKey) {
        this.hlsUrl = this.item.url;
        return;
      }
      if (this.hlsLinks[this.cdnUrlKey]) {
        this.hlsUrl = this.hlsLinks[this.cdnUrlKey];
      } else {
        this.$axios({
          url: `${this.apiUrl}/coobo_ms/get-jio-hls-url`,
          data: {
            url: this.item[this.cdnUrlKey],
          },
          method: 'post',
        }).then(({data}) => {
          if (data.data) {
            this.hlsUrl = data.data;
            this.hlsLinks[this.cdnUrlKey] = data.data;
          }
        }).catch((e) => {
          console.log(e.message || "Unknown Error");
        })
      }
    },
    getVimeoLink() {
      if (!this.cdnUrlKey) {
        this.hlsUrl = this.item.url;
        return;
      }

      if (this.vimeoLinks[this.cdnUrlKey]) {
        this.hlsUrl = this.vimeoLinks[this.cdnUrlKey];
      } else {
        let vimeoMatch = this.item[this.cdnUrlKey].match(/vimeo.com\/(\d+)\/?/i);
        let vimeoId = (vimeoMatch || [])[1];
        if (vimeoId) {
          getVimeoLink(vimeoId, this.item.language).then((link) => {
            if (link) {
              this.hlsUrl = link;
              this.vimeoLinks[this.cdnUrlKey] = link;
            }
          })
        }
      }
    },
    getSortedPowerSchoolFields(powerSchoolObj) {
      let powerSchoolKeys = Object.keys(powerSchoolObj);

      const sortByOrder = (a, b) => {
        const indexA = this.fieldsOrder.indexOf(this.mapFieldKey(a).toLowerCase());
        const indexB = this.fieldsOrder.indexOf(this.mapFieldKey(b).toLowerCase());

        if (indexA === -1 && indexB === -1) {
          return 0;
        } else if (indexA === -1) {
          return 1;
        } else if (indexB === -1) {
          return -1;
        } else {
          return indexA - indexB;
        }
      }

      return powerSchoolKeys.sort(sortByOrder)
    },
    getCspLms(id, type) {
      return this.$axios({
        url: `${this.apiUrl}/coobo_ms/csp-learning-maps`,
        data: {
          "id": id,
          "locale": this.item.language,
          "type": type
        },
        method: 'post',
      }).then(({data}) => {
        if (data && data.fullLms) {
          this.lmsFields = data.fullLms;
        }
      }).catch((e) => {
        console.log(e.message);
        return null
      })
    },
    getIframeLink() {
      if (this.item.asset_type === 'simulations') {
        return this.viewLink;
      } else if (this.item.asset_type === 'coobos') {
        return this.getCooboLink(this.item[this.cdnType]);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ga-modal-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 10px;
  overflow: hidden;
  width: 100%;
  position: relative;
}

.ga-modal-title {
  padding: 7px 7px 7px 0;
  margin-right: auto;
}

.ga-modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ga-modal-table {
  min-height: 30px;
  flex-shrink: 0;
}

.ga-modal-asset-link {
  margin-top: 20px;
}

.ga-modal-table-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 20px;
  overflow: auto;
  overflow-x: hidden;
  padding:5px;
}

.coobo-links {
  max-width: 60%;
  justify-content: flex-end;
  display: flex;
  flex-wrap: wrap;
}
.ga-modal-view-btn {
  padding: .75rem 2rem;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  color: #fff;
  background: #7367f0;
  flex-shrink: 0;
  margin: 0 0 5px 5px;
}
.ga-modal-view-btn.selected {
  pointer-events: none;
  opacity: 0.6;
}

.custom-input-group {
  width: 500px;
  max-width: 100%;
  margin: 20px auto 5px;

  .vx-input-group-append .append-text.btn-addon .vs-button:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
}
.language-select {
  min-width: 200px;
  margin-left: 10px;
}
</style>
